import React, { useState, useEffect, useRef } from "react";
import "./SearchFood.scss";
import Icon from "../../_default/Icon";
import useOnclickOutside from "react-cool-onclickoutside";

function SearchFood({ placeholder, value, onClick, onChange, filterClients, response }) {
  const [initiated, setInitiated] = useState(false);
  const [hits, _setHits] = useState(false);
  const [key_index, _set_key_index] = useState(0);
  const [scrollHeight, _setScrollHeight] = useState(0);
  const [local_value, set_local_value] = useState(value ? value : "");
  const [searchEvent, setSearchEvent] = useState(false);
  const textInput = useRef();
  const key_index_ref = useRef(key_index);
  const scrollHeight_ref = useRef(scrollHeight);
  const [searchFood,setSearchFood]=useState("")
  const hits_ref = useRef(hits);

  
  const setHits = (data) => {
    
    hits_ref.current = data;
    _setHits(data);
  };

  const set_key_index = (data) => {
    key_index_ref.current = data;
    _set_key_index(data);
  };

  const setScrollHeight = (data) => {
    scrollHeight_ref.current = data;
    _setScrollHeight(data);
  };

  const ref = useOnclickOutside(() => {
    setHits(false);
    set_key_index(0);
    setScrollHeight(0);
  });

  useEffect(() => {
    if (hits) {
      if (textInput.current !== null && !initiated) {
        setInitiated(true);
        window.addEventListener("keydown", (e) => keydownListener(e), true);
      }
    }

    return () => {
      window.removeEventListener("keydown", (e) => keydownListener(e), true);
    };
  }, [hits]);

  // useEffect(() => {
  //   
  //   if (hits) {
  //     isOpen(true);
  //   } else {
  //     isOpen(false);
  //   }
  // }, [hits]);

  useEffect(() => {
    set_local_value(value);
  }, [value]);

  const keydownListener = (e) => {
    if (e.keyCode === 40 && key_index_ref.current < hits_ref.current.length - 1) {
      set_key_index(key_index_ref.current + 1);
      if (key_index_ref.current > 0 && textInput.current.scroll !== null) {
        let newScrollHeight = scrollHeight_ref.current;
        textInput.current.scroll({
          top: scrollHeight_ref.current,
          left: 0,
          behavior: "smooth",
        });
        newScrollHeight += 35;
        setScrollHeight(() => newScrollHeight);
      }
    }
    if (e.keyCode === 38 && key_index_ref.current > 0) {
      set_key_index(key_index_ref.current - 1);
      if (scrollHeight_ref.current >= 0 && textInput.current.scroll !== null) {
        let newScrollHeight = scrollHeight_ref.current;
        textInput.current.scroll({
          top: scrollHeight_ref.current,
          left: 0,
          behavior: "smooth",
        });
        newScrollHeight -= 35;
        setScrollHeight(() => newScrollHeight);
      }
    }
    if (e.keyCode === 13) {
      handleHitClick(hits_ref.current[key_index_ref.current]);
    }
    if (e.keyCode === 27) {
      setHits(false);
      set_key_index(0);
      setScrollHeight(0);
    }
  };

  const searchClient = (event) => {
    set_local_value(event.target.value);
    onChange(searchEvent);
    console.log(event.target.value);
    if(event.target.value !== ""){
      setSearchFood(event.target.value)
      fetch(`https://world.openfoodfacts.org/cgi/search.pl?search_terms=${event.target.value}&search_simple=1&action=process&json=true&page_size=100`)
      // fetch(`https://world.openfoodfacts.org/cgi/search.pl?search_terms=${event.target.value}&search_simple=1&action=process&json=true&page_size=100`)
      // fetch(`https://api.spoonacular.com/food/products/search?query=${event.target.value}&apiKey=f29bf8a6bd9b40ef8ed2b568fdff9775`)
      // fetch(`https://api.spoonacular.com/food/products/search?query=quaker&apiKey=f29bf8a6bd9b40ef8ed2b568fdff9775`)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        let filterData=data?.products.filter((data)=>data.product_name=="whole egg")
        console.log("filter out eggs",filterData)
        setHits(data.products)
        // filterClients(data.products)
      });
    }
  };


  function handleHitClick(hit) {
    console.log('____');
    console.log(hit);
    if (hit) {
      onClick(hit);
      setHits(false);
      set_key_index(0);
      setScrollHeight(0);
    }
  }

  return (
    <div ref={ref} className="c-search-wrapper c-search-food-wrapper">
      <div className="c-search-food">
        <input placeholder={placeholder ? placeholder : "Search product"} required value={local_value} type="text"  onChange={(e) => { set_local_value(e.target.value); setSearchEvent(e) } } autofill="off" autocomplete="off" />
        <div onClick={(e) => searchClient(searchEvent)} style={{cursor:"pointer"}}><Icon icon="search" /></div>
      </div>
      {hits && (
        searchFood.toLowerCase()=="whole egg"?
        <div ref={textInput} className="c-search-food-results">
          {hits.map((hit, idx) => (
            hit.product_name_en ? (
            // hit.product_name ? (
              <div key={idx} className={key_index === idx ? "c-hit --selected" : "c-hit"} onClick={() => handleHitClick(hit)}>
                <div style={{ backgroundImage: `url("${hit.image_url}")`}} className="c-small-food-image"/>
                <div className="c-hit-text-wrapper">
                <p>{hit.product_name_en}</p>
                {/* <p>{hit.product_name}</p> */}
                <span>{hit.nutriments["energy-kcal_100g"]} {hit.nutriments["energy-kcal_unit"]} per 100g</span>
                </div>
               
              </div>
              ) : <></>
            
          ))}
        </div>:
        <div ref={textInput} className="c-search-food-results">
        {hits.map((hit, idx) => (
          // hit.product_name_en ? (
          hit.product_name ? (
            <div key={idx} className={key_index === idx ? "c-hit --selected" : "c-hit"} onClick={() => handleHitClick(hit)}>
              <div style={{ backgroundImage: `url("${hit.image_url}")`}} className="c-small-food-image"/>
              <div className="c-hit-text-wrapper">
              {/* <p>{hit.product_name_en}</p> */}
              <p>{hit.product_name}</p>
              <span>{hit.nutriments["energy-kcal_100g"]} {hit.nutriments["energy-kcal_unit"]} per 100g</span>
              </div>
             
            </div>
            ) : <></>
          
        ))}
      </div>
      )}
    </div>
  );
}

export default SearchFood
